import DevService from './dev.service.empty'
const devModule = angular.module('app.dev', [])
  .service('DevService', DevService)
  .name

export default devModule
